// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_DRAGONS = [{
  id: 'dragons_mountains',
  factionId: FACTIONS.DRAGONS,
  name: 'Горный зверь',
  priceNumens: 15000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.ORANGE,
  ]
}, {
  id: 'dragons_fly',
  factionId: FACTIONS.DRAGONS,
  name: 'Хозяин небес',
  priceNumens: 43000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.RED,
    PLAYER_COLORS.BLUE,
  ]
}, {
  id: 'dragons_fortress',
  factionId: FACTIONS.DRAGONS,
  name: 'Гроза цитаделей',
  priceNumens: 90000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.RED,
  ]
}, {
  id: 'dragons_gold_legacy',
  factionId: FACTIONS.DRAGONS,
  name: 'Хранитель клада',
  priceNumens: 100000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'dragons_ruby_legacy',
  factionId: FACTIONS.DRAGONS,
  name: 'Вожак огненной стаи',
  priceCrystals: 450,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
